import { useEffect } from 'react';
import { useAppContext, appContext, stringifyPublisher } from '@provider/app-context';
import { FormattedList } from '@utils/react';
import { header, context } from './pm2.header.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const PM2PrintHeaderSlot = () => ({
  content: /*#__PURE__*/jsx(PM2PrintHeader, {}),
  designSizeInPx: {
    width: 794,
    height: 1123
  }
});
function PM2PrintHeader() {
  const publisher = useAppContext(state => state.publisher);
  const product = useAppContext(state => state.product);
  const course = useAppContext(state => state.course?.title);
  const authors = useAppContext(state => state.authors);
  useEffect(() => {
    appContext.getPageAuthors().catch(() => {
      /** no-op */
    });
  }, []);
  const productLabel = product?.subject ? `${product.subject}${product.gradesLabel ? ` ${product.gradesLabel}` : ""}${product.classLabel ? ` ${product.classLabel}` : ""}` : product?.title;
  return /*#__PURE__*/jsx("header", {
    className: header,
    children: /*#__PURE__*/jsxs("div", {
      className: context,
      children: [(product || course) && /*#__PURE__*/jsxs("span", {
        children: [course && /*#__PURE__*/jsxs("span", {
          children: ["Fra ", /*#__PURE__*/jsx("b", {
            children: course
          })]
        }), !!authors?.length && /*#__PURE__*/jsxs("span", {
          children: [" ", "af ", /*#__PURE__*/jsx(FormattedList, {
            children: authors
          })]
        }), product && /*#__PURE__*/jsxs("span", {
          children: [course || authors?.length ? `, ` : "", productLabel]
        }), /*#__PURE__*/jsx("span", {
          children: " | "
        })]
      }), /*#__PURE__*/jsxs("span", {
        children: [stringifyPublisher(publisher), "s fagportaler,", " ", stringifyPublisher(publisher)]
      })]
    })
  });
}

export { PM2PrintHeaderSlot };
//# sourceMappingURL=pm2.header.js.map
